import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { useContext, useEffect } from 'react';
import useCustomHook from '@/hooks/useCustomHook';

export default function useVideoActivity({ activity, demoMode }) {
  const globalContext = useContext(GlobalContext);

  const { state, actions } = useCustomHook({
    defaultState: {
      urls: null,
      posterUrl: null,
      canIncreasePlaybackRate: false,
    },
  });

  useEffect(() => {
    if (activity?.data && globalContext.state.loaded) {
      const { videoUrls, introVideoUrls, poster } = activity.data;
      const videoUrlsToUse =
        demoMode && !activity.free ? introVideoUrls : videoUrls;

      if (videoUrlsToUse?.length) {
        const urls = videoUrlsToUse
          .filter(
            (videoUrl) =>
              videoUrl.type.includes('VideoFile') ||
              (process.env.NEXT_PUBLIC_HLS_ENABLED &&
                videoUrl.type.includes('VideoHLS'))
          )
          .map((videoUrl) => ({
            ...videoUrl,
            url: videoUrl.url.includes('embed.wistia')
              ? `//${videoUrl.url.replace('embed.', 'embed-ssl.')}`
              : videoUrl.url,
          }))
          .sort((videoUrl1, videoUrl2) => videoUrl2.height - videoUrl1.height);

        const rawPosterUrl =
          poster || videoUrls.find((url) => url.type == 'StillImageFile').url;
        const posterUrl = rawPosterUrl.includes('embed.wistia')
          ? `//${rawPosterUrl.replace('embed.', 'embed-ssl.')}`
          : rawPosterUrl;

        actions.setState({
          urls,
          posterUrl,
        });
      }
    }
  }, [activity, globalContext.state, demoMode]);
  return { state, actions };
}
